export default __webpack_public_path__ + "static/media/home-yoga-meditation-mindfullness-bg.a2322579.jpg";